var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from "react";
var ReloadableReportDataContext = createContext({ data: { filterCheckOverride: false }, setData: function () { } });
export var ReloadableReportDataProvider = function (_a) {
    var children = _a.children, _b = _a.filterCheckOverride, filterCheckOverride = _b === void 0 ? false : _b;
    var _c = useState({
        filterCheckOverride: filterCheckOverride,
    }), data = _c[0], setData = _c[1];
    return (_jsx(ReloadableReportDataContext.Provider, __assign({ value: { data: data, setData: setData } }, { children: children })));
};
export var useReloadableReportData = function () {
    var context = useContext(ReloadableReportDataContext);
    if (!context) {
        // Return a no-op version for components not wrapped in ReportDataProvider
        return {
            data: {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            setData: (function () { }),
        };
    }
    return context;
};
